<template>
  <div class="participant">
  </div>
</template>

<script>
export default {
  name: 'participant',
  data () {
    return {

    }
  },
  components: {

  },
  mounted() {

  },
  methods: {

  },
}

</script>
<style scoped lang='scss'>
.participant{
    background: url("@/assets/images/asEditorH5/markbg@2x.png") no-repeat;
    background-size: 100% 100%;
     width: 100%;
    height: 55px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>